
 <template>
  <el-dialog
    :visible.sync="show"
    :close-on-click-modal="false"
    @close="close"
    center
    width="60%"
    append-to-body
    destroy-on-close
    title="设置标签"
  >
    <div v-if="show">
      <el-checkbox-group v-model="checkbox">
        <el-checkbox
          v-for="tag in tags"
          :label="tag.id"
          :value="tag.id"
          :key="tag.id"
          >{{ tag.name }}</el-checkbox
        >
      </el-checkbox-group>
      <div :class="$style.buttons">
        <el-button
          :loading="loading"
          type="primary"
          @click="postData"
          size="mini"
          >保存</el-button
        >
        <el-button @click="close" size="mini">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { editTags } from "./api";
export default {
  name: "EditDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    item: {},
    tags: {
      type: Array,
    },
  },
  data() {
    return {
      loading: false,
      inited: false,
      checkbox: [],
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.item) {
            this.editInit();
          }
        });
      }
    },
  },
  methods: {
    close() {
      this.$emit("update:show", false);
    },
    async postData() {
      if (this.loading) return;
      let rep = await editTags({
        id: this.item.branch_id,
        tags: this.checkbox,
      });
      let { code, msg } = await rep.json();
      this.loading = false;
      if (code !== 200) {
        this.$message.error(msg);
      }
      this.$emit("callback");
      this.$message("提交成功");
      this.close();
    },
    async editInit() {
      this.checkbox = this.item.tags.map((tag) => tag.id);
      this.inited = true;
    },
  },
};
</script>

<style lang="scss" module>
.buttons {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
</style>
